import Swiper from '../../scripts/vendor/swiper-bundle';

function initSwiper(swiperEl = null) {
  if (swiperEl) {
    initSwiperEl(swiperEl);
    return;
  }
  const swiperEls = document.querySelectorAll('.swiper:not([thumbsSlider])');

  swiperEls.forEach((swiperEl) => {
    initSwiperEl(swiperEl);
  });
}


function initSwiperEl(swiperEl) {
  const options = JSON.parse(swiperEl.dataset.swiper || {});
  const swiper = new Swiper(swiperEl, { ...options });
  const thumbsSwiperEl = swiperEl.parentElement.querySelector('.swiper[thumbsSlider]');
  if (thumbsSwiperEl) {
    adjustSwiper3dHeight(swiperEl, thumbsSwiperEl);
    swiper.on('slideChange', function () {
      if (swiper.activeIndex === 0) {
        swiper.allowTouchMove = false;
      } else {
        swiper.allowTouchMove = true;
      }
    });

    if (swiper.activeIndex === 0) {
      swiper.allowTouchMove = false;
    }

    // main-product-swiper
    const swiperSlides = thumbsSwiperEl.querySelectorAll('.swiper-slide');
    if (swiperSlides) {
      swiperSlides.forEach((swiperSlide) => {
        swiperSlide.addEventListener('mouseover', () => {
          const isActive = swiperSlide.classList.contains('swiper-slide-thumb-active');
          const ariaLabel = swiperSlide.getAttribute('aria-label');
          if (ariaLabel && !isActive) {
            const sliderIndex = parseInt(ariaLabel.split('/')[0].replace(/\s/g, '')) - 1;
            swiper.slideToLoop(sliderIndex, 0, false);
          }
        });
      });
    }
  }

  const zoomEls = swiperEl.querySelectorAll('.image-magnify-click');
  zoomEls.forEach((zoomEl) => {
    zoomEl.addEventListener('mouseover', (e) => {
      swiper.zoom.in();
    });
    zoomEl.addEventListener('mouseout', (e) => {
      swiper.zoom.out();
    });
  });
}
function adjustSwiper3dHeight(swiperEl, thumbsSwiperEl) {
  const swiperWrapperHeight = swiperEl.offsetHeight;
  const fibblImageWrapper = swiperEl.querySelector('.fibbl-image-wrapper');
  if (!fibblImageWrapper) return;
  const swiperSlide = fibblImageWrapper.closest('.swiper-slide');
  if (!swiperWrapperHeight || !swiperSlide) return;
  swiperSlide.style.height = swiperWrapperHeight + 'px';
  fibblImageWrapper.style.height = swiperWrapperHeight + 'px';
}


document.addEventListener('DOMContentLoaded', initSwiper());

export default initSwiper;
